<template>
  <rabbey-base-drawer
    :title="title"
    size="70%"
    :drawer.sync="drawer"
    v-loading.fullscreen.lock="loading"
    :with-header="true"
    v-bind="$attrs"
    @close="OnClose"
    @closed="OnClose"
  >
    <el-row>
      <el-col>
        <el-form
          :model="data"
          label-position="left"
          size="mini"
          label-width="120px"
        >
          <h2>{{ data.Name }}</h2>
          <div class="tags">
            <el-tooltip
              effect="dark"
              content="Clasificacion"
              placement="top-start"
              size="mini"
              :disabled="!data.Clasification"
            >
              <el-tag type="success" v-if="data.Clasification" size="mini">{{
                data.Clasification
              }}</el-tag>
            </el-tooltip>

            <el-tooltip
              effect="dark"
              content="Estatus"
              placement="top-start"
              :disabled="!data.Status"
              size="mini"
            >
              <el-tag type="success" v-if="data.Status" size="mini">{{
                data.Status
              }}</el-tag>
            </el-tooltip>

            <el-tooltip
              effect="dark"
              content="Dias de crédito"
              placement="top-start"
              :disabled="!data.PaymentDay"
              size="mini"
            >
              <el-tag type="success" v-if="data.PaymentDay" size="mini">{{
                data.PaymentDay
              }}</el-tag>
            </el-tooltip>

            <el-tag size="mini">{{ data.ClientType }}</el-tag>

            <el-tooltip
              placement="top-start"
              :content="
                data.ContractStatus >= 1
                  ? 'Contrato del cliente abierto'
                  : 'Contrato del cliente cerrado'
              "
            >
              <el-tag
                :type="data.ContractStatus >= 1 ? 'success' : 'danger'"
                size="mini"
                >CN</el-tag
              >
            </el-tooltip>

            <template v-if="currentCompany === companys.MTR">
              <el-tooltip
                :content="
                  data.StatusNavixy
                    ? 'Servicio en Plataforma activo'
                    : 'Servicio en Plataforma desactivado'
                "
                placement="top-start"
                effect="dark"
              >
                <el-tag
                  :type="data.StatusNavixy ? 'success' : 'danger'"
                  size="mini"
                  >SP</el-tag
                >
              </el-tooltip>
            </template>

            <template v-if="data.OverdueBillsQty > 0">
              <el-tooltip
                content="Facturas vencidas"
                placement="top-start"
                effect="dark"
              >
                <el-tag type="danger" size="mini"
                  >FV: {{ data.OverdueBillsQty }}</el-tag
                >
              </el-tooltip>
            </template>
          </div>
          <hr />

          <el-row :gutter="20" type="flex column">
            <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
              <el-form-item label="Codigo">
                <el-input v-model="data.ClientCode" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="RNC">
                <el-input
                  v-model="data.VatRegistrationNumber"
                  :disabled="true"
                />
              </el-form-item>

              <el-form-item label="Telefono">
                <el-input v-model="phone" :disabled="true"></el-input>
              </el-form-item>

              <label
                class="text-no-modified"
                v-if="
                  !IsInRoles([
                    roles.SupervisorDeSoporteDeVentas,
                    roles.SupervisorDeVentas
                  ])
                "
                >Solo los supervisores de ventas pueden modificar esta
                Informacion</label
              >
              <el-form-item label="Vendedor">
                <SellerSelectorCodeString
                  v-model="SalesPersonCode"
                  :editAgent="true"
                />
              </el-form-item>

              <label
                class="text-no-modified"
                v-if="!IsInRoles([roles.CoornidadorDeServicioAlCliente])"
                >Solo los coordinadores de servicio al cliente puede modificar
                esta informacion</label
              >
              <el-form-item label="Servicio">
                <CustomerServiceSelector
                  v-model="CustomerService"
                  :editAgent="true"
                />
              </el-form-item>
            </el-col>

            <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
              <el-form-item label="Email">
                <el-input
                  v-model="customerEmail"
                  :placeholder="data.Email"
                  :disabled="false"
                ></el-input>
              </el-form-item>

              <el-form-item label="Direccion">
                <el-input v-model="data.Address" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Ciudad">
                <el-input v-model="data.City" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item label="Zona">
                <el-input v-model="data.Zone" :disabled="true"></el-input>
              </el-form-item>

              <label
                class="text-no-modified"
                v-if="!IsInRoles([roles.CuentasPorCobrar])"
                >Solo los de cuenta por cobrar pueden hacer modificaciones en
                esta parte</label
              >
              <el-form-item label="Gestor de Cobro">
                <PaymentAgentSelector
                  v-model="PaymentAgent"
                  :editAgent="true"
                />
              </el-form-item>
            </el-col>

            <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
              <el-form-item label="# Empleados">
                <el-input
                  v-model="empleadosQ"
                  :disabled="false"
                  :placeholder="data.EmployeesQuantity"
                  type="number"
                ></el-input>
              </el-form-item>

              <el-form-item label="# Computadoras">
                <el-input
                  v-model="pcQ"
                  :disabled="false"
                  :placeholder="data.PcQuantity"
                  type="number"
                ></el-input>
              </el-form-item>

              <el-form-item label="# Vehiculos">
                <el-input
                  v-model="vehiculosQ"
                  :placeholder="data.VehiclesQuantity"
                  type="number"
                ></el-input>
              </el-form-item>

              <el-form-item label="# Clientes">
                <el-input
                  v-model="clientesQ"
                  :disabled="false"
                  :placeholder="data.ClientQuantity"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-button type="primary" @click="editCustomers()">Editar</el-button>

          <!-- <el-row class="mt-20">
            <el-col>
              <el-tabs v-model="activeName" :before-leave="onBeforeLeave">
                <el-tab-pane label="Contactos" name="contacts">
                  <TableContacts
                    v-if="activeName === 'contacts'"
                    ref="contacts"
                    :clientCode="data.ClientCode"
                  />
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row> -->
        </el-form>
      </el-col>
    </el-row>
  </rabbey-base-drawer>
</template>

<script>
import { COMPANYS } from "@/const";
import { formatPhoneNumber } from "@/utils";
import SellerSelectorCodeString from "@/components/Company/SellerSelectorCodeString.vue";
import CustomerServiceSelector from "@/components/Company/CustomerServiceSelector.vue";
import PaymentAgentSelector from "@/components/Company/PaymentAgentSelector.vue";
// import TableContacts from "./TableContacts.vue";

export default {
  name: "EditCustomer",
  inheritAttrs: false,
  components: {
    SellerSelectorCodeString,
    CustomerServiceSelector,
    PaymentAgentSelector
  },
  props: {
    CustomerData: {
      type: Object
    },
    ChangeActiveName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userService: "",
      userSeller: "",
      empleadosQ: null,
      pcQ: null,
      vehiculosQ: null,
      clientesQ: null,
      customerEmail: null,
      customerId: null,
      SalesPersonCode: null,
      CustomerService: null,
      PaymentAgent: null,
      companys: COMPANYS,
      activeColapseName: ["1"],
      data: {},
      drawer: false,
      title: "Editar Cliente",
      loading: false,
      activeName: "contacts",
      contractNo: "",
      UploadHeader: "",
      editable: {
        CustomerCode: "",
        cantEmpleados: null,
        cantComputadora: null,
        cantVehiculos: null,
        cantClientes: null,
        email: null,
        sellerCode: null,
        serviceCode: null,
        paymentAgentCode: null
      }
    };
  },
  // created() {
  //   this.SalesPersonCode = null;
  //   this.CustomerService = null;
  // },
  methods: {
    editCustomers() {
      this.editable.CustomerCode = this.data.ClientCode;
      this.editable.cantEmpleados = this.empleadosQ;
      this.editable.cantComputadora = this.pcQ;
      this.editable.cantVehiculos = this.vehiculosQ;
      this.editable.cantClientes = this.clientesQ;
      this.editable.email = this.customerEmail;
      this.editable.sellerCode = this.SalesPersonCode;
      this.editable.serviceCode = this.CustomerService;
      this.editable.paymentAgentCode = this.PaymentAgent;

      if (
        this.editable.cantEmpleados < 0 ||
        this.editable.cantComputadora < 0 ||
        this.editable.cantVehiculos < 0 ||
        this.editable.cantClientes < 0
      ) {
        this.$message.error("Error al editar Cliente");
      } else {
        this.$http
          .post("/api/customers/Editcustomer", this.editable)
          .then(() => {
            this.$message({
              type: "success",
              message: "Cliente editado con exito!"
            });
            this.$emit("refresh");
          })
          .catch((error) => {
            console.error(error);
            this.$message.error("Error al editar Cliente");
          });
        this.drawer = false;
      }
    },
    formatPhoneNumber,
    // eslint-disable-next-line no-unused-vars
    onBeforeLeave(activeName) {
      this.activeName = activeName;

      // this.$nextTick(() => {
      //   this.$refs[activeName].getItems();
      // });
      this.activeName = "contacts";
    },
    async show(data) {
      this.userService = this.$store.getters["user/getterbyExec"](
        data.CustomerServiceName
      );
      this.userSeller = this.$store.getters["user/getterbySeller"](
        data.SalesPersonCode
      );

      this.data = data;
      this.SalesPersonCode = this.data.SalesPersonCode;
      this.PaymentAgent = this.data.AccountReceivableCode;
      this.CustomerService = this.userService.Id;
      this.activeName = "contacts";
      this.drawer = true;

      // this.$nextTick(() => {
      //   this.$refs.contacts.getItems();
      // });
    },

    OnClose() {
      this.ChangeActiveName = "";
      this.empleadosQ = null;
      this.pcQ = null;
      this.vehiculosQ = null;
      this.clientesQ = null;
      this.customerEmail = null;
      this.SalesPersonCode = null;
      this.CustomerService = null;
      this.PaymentAgent = null;
    }
  },
  computed: {
    phone() {
      return this.formatPhoneNumber(this.data.PhoneNumber);
    }
  },
  watch: {
    ChangeActiveName() {
      if (this.ChangeActiveName != "") {
        this.activeName = this.ChangeActiveName;
        this.ChangeActiveName = "";
      }
    }
  }
};
</script>

<style lang="scss">
.el-tabs__nav-scroll {
  .el-badge__content {
    &.is-fixed {
      top: 10px !important;
      right: 0px !important;
    }
  }
}

.tags span:not(:first-child) {
  margin-left: 5px;
}

.text-no-modified {
  color: red;
  font-size: 10px;
}
</style>
